import * as React from 'react';

export interface IAboutProps {
}

export function About(props: IAboutProps) {
    return (
        <section className="about-section">
            <div className="about-container">
                <div className="about-content">
                    <div className="about-image">
                        <img src="./assets/images/IMG_0831.png" alt="Profile" className="about-profile-image" />
                    </div>
                    <div className="about-text">
                        <h2 className="about-title">About Me</h2>
                        <h3 className="about-name">Vishnu Das</h3>
                        <h4 className="about-role">Java Full Stack Developer</h4>
                        <p className="about-description">
                            I am a highly skilled Java Architect with 12 years of experience in designing and developing robust and scalable software solutions. With a deep understanding of Java technologies and architectural principles, I excel in delivering high-quality, performance-driven systems that meet business objectives.
                        </p>
                        <p className="about-skills">
                            <strong>Key Skills:</strong><br />
                            Java/J2EE: Expert in Java programming language and frameworks like Spring, Spring Boot, Hibernate, and Java EE. Proficient in leveraging Java features to build efficient, maintainable, and extensible applications.
                        </p>
                        
                        <div className="personal-info">
                            <div className="info-item">
                                <strong>Date Of Birth:</strong> 11th March 1990
                            </div>
                            <div className="info-item">
                                <strong>Phone:</strong> +46 767025106  | +91 8943014949
                            </div>
                            <div className="info-item">
                                <strong>Email:</strong> vishnumohandas11@gmail.com
                            </div>
                            <div className="info-item">
                                <strong>Address:</strong> Storgatan 64, 17152 Solna, Stockholm Sweden
                            </div>
                            <div className="info-item">
                                <strong>Website:</strong> https://www.vishnumohandas11.in
                            </div>
                        </div>
                        
                        <div className="services-section">
                            <h3 className="services-title">What I'm Doing</h3>
                            <div className="services-grid">
                                <div className="service-item">
                                    <div className="service-icon">
                                        <img src="./assets/images/icon-java.png" alt="Java" />
                                    </div>
                                    <h5>Java Developer</h5>
                                </div>
                                <div className="service-item">
                                    <div className="service-icon">
                                        <img src="./assets/images/icon-reactjs.png" alt="React" />
                                    </div>
                                    <h5>Web App Development</h5>
                                </div>
                                <div className="service-item">
                                    <div className="service-icon">
                                        <img src="./assets/images/icon-cloud.png" alt="Cloud" />
                                    </div>
                                    <h5>Cloud Computing</h5>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
